export default "__VITE_ASSET__CaUDnIR9__"